import { Button, Col, Typography } from "@commonlibs";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";
import { AuthRoutes } from "ui/auth/router/AuthRouter.types";
import useTabsState from "ui/common/components/navigation/StatefulTabs/hooks/useTabsState";
import { MailInboxIcon } from "ui/common/icons";
import useTranslate from "ui/locale/hooks/useTranslate";
import { RecoverPasswordTabState } from "../RecoverPasswordTabs.types";

function SuccessTab() {
    const translate = useTranslate();
    const { spacing } = useTheme();
    const navigate = useNavigate();
    const [state] = useTabsState<RecoverPasswordTabState>();
    const data = state?.recoveryData;

    const buildNotificationChannelMessage = (preferences?: {
        emailNotifications?: boolean;
        smsNotifications?: boolean;
    }): string => {
        if (!preferences) return "";

        const channels: string[] = [];
        const media: string[] = [];

        if (preferences.emailNotifications) {
            channels.push(`Correo electrónico: ${data?.email}`);
            media.push('tu bandeja de entrada');
        }
        if (preferences.smsNotifications) {
            channels.push(`Número de celular: ${data?.sms}`);
            media.push('tus mensajes de texto');
        }

        const newMessage = channels.join(" \\n ");
        const newFormat = media.join(" y/o ");

        const previewMessaje = translate("changePasswordSuccess")
            .replace("{{message}}", newMessage)
            .replace("{{format}}", newFormat)
            .replace(/\\n/g, "\n");

        return previewMessaje;
    };

    const message = buildNotificationChannelMessage(data?.preferences);

    return (
        <Col className={clsx("success-tab")} justifyContent="center" alignItems="center" gap={spacing[8]}>
            <MailInboxIcon fontSize={spacing[20]} />
            <Typography variant="body2Light" light textAlign={"center"}>
                {message.split("\n").map((line) => (
                    <span key={line}>
                        {line}
                        <br />
                    </span>
                ))}
            </Typography>
            <Button variant="primary" fullWidth onClick={() => navigate(AuthRoutes.MAIN)}>
                {translate("goToHome")}
            </Button>
        </Col>
    );
}

export default SuccessTab;
